import { createFileRoute, Link, redirect } from '@tanstack/react-router';

import { NotificationSettingsChannel } from '@apps/web/components/settings/notification_settings_channel';
import { SettingsPageShell } from '@apps/web/features/settings';
import {
    isNotificationChannelSlug,
    notificationChannelPageForSlug,
} from '@apps/web/lib/notification_channel_pages';

export const Route = createFileRoute('/_app/settings/notifications/$channel')({
    beforeLoad: ({ params }) => {
        if (!isNotificationChannelSlug(params.channel)) {
            throw redirect({ to: '/settings/notifications' });
        }
    },
    component: NotificationChannelRoute,
});

function NotificationChannelRoute() {
    const { channel } = Route.useParams();
    if (!isNotificationChannelSlug(channel)) {
        return null;
    }
    return (
        <SettingsPageShell
            title={notificationChannelPageForSlug(channel).label}
            eyebrow={
                <Link
                    to="/settings/notifications"
                    className="text-muted-foreground hover:text-foreground text-sm pointer-coarse:inline-flex pointer-coarse:min-h-11 pointer-coarse:items-center"
                >
                    ← Notifications
                </Link>
            }
        >
            <NotificationSettingsChannel key={channel} slug={channel} />
        </SettingsPageShell>
    );
}
